<template>
  <div>
      <a-card title="项目列表">
      <a-button slot="extra" type="primary"  @click="handleNewProject">新建项目</a-button>

            <a-table :columns="columns" :data-source="data" :pagination="false" :loading="tLoading" rowKey="projectName" >
                <a slot="name" @click="handleProjectClick(text)" slot-scope="text">{{ text }}</a>

                <span slot="ctime" slot-scope="text">{{ G.formatTimesapn(text,'yyyy-MM-dd hh:mm:ss') }}</span>

                <span slot="utime" slot-scope="text">{{ G.formatTimesapn(text,'yyyy-MM-dd hh:mm:ss') }}</span>
                <template slot="operation" slot-scope="text, record">
                <div >
                    <span>
                        <a-button type="link" @click="handleProjectClick(record.projectName)">查询</a-button>
                    </span>
                </div>

                
            </template>
            </a-table>
      </a-card>
  </div>
</template>
<script>
const columns = [

    {
        title: '项目名称',
        dataIndex: 'projectName',
        key: 'projectName',
        scopedSlots:{customRender:'name'}
    },
    {
        title: '项目描述',
        dataIndex: 'projectDesc',
        key: 'projectDesc',
    },
    {
        title: '状态',
        dataIndex: 'projectStatus',
        key: 'projectStatus',
    },

    {
        title: '创建时间',
        dataIndex: 'createTime',
        key: 'createTime',
        scopedSlots:{customRender:'ctime'}
    },
    {
        title: '修改时间',
        dataIndex: 'updateTime',
        key: 'updateTime',
        scopedSlots:{customRender:'utime'}
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 120,
        scopedSlots: { customRender: 'operation' },
    }

];
export default {
    
    data() {
        return {
            columns,
            data:[],
            tLoading:true
        };
    },
    methods: {

        handleNewProject(){
            this.$router.push({
                path: "projectadd",
                query: {id:''}
            });
        },
        handleProjectClick(projectname){
            this.$router.push({
                path: "logstoremanager",
                query: {projectname:projectname}
            });
            
        }
    },
    computed:{
        
    },
    components:{
        
    },
    mounted(){
        //查询project列表
        let that = this;
        // createTime: "1599631108"
        // projectDesc: "云效"
        // projectName: "yunxiao"
        // projectStatus: "Normal"
        // updateTime: "1599631108"
        this.tLoading = true;
        that.$store.dispatch({
            type: "logservice/querylogproject",
            params:{
                urlparams:false
            }
        }).then((res)=>{
            if(res.status == 200){
                that.data = res.data.data.projectlist;
            }
            that.tLoading = false;
        });

    }
};
</script>
<style scoped>


</style>
